module.exports = __webpack_public_path__ + "img/ft-logo.06dbda5a.png";